// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { OGCWebServiceLayerRead } from "./OGCWebServiceLayerRead";
import {
  OGCWebServiceLayerReadFromJSON,
  OGCWebServiceLayerReadFromJSONTyped,
  OGCWebServiceLayerReadToJSON,
  OGCWebServiceLayerReadToJSONTyped,
} from "./OGCWebServiceLayerRead";

/**
 *
 * @export
 * @interface OGCWebServiceRead
 */
export interface OGCWebServiceRead {
  /**
   *
   */
  protocol: OGCWebServiceReadProtocolEnum;
  /**
   *
   */
  url: string;
  /**
   *
   */
  layers: Array<OGCWebServiceLayerRead>;
}

/**
 * @export
 */
export const OGCWebServiceReadProtocolEnum = {
  OgcWms: "OGC:WMS",
  OgcWfs: "OGC:WFS",
  OgcWcs: "OGC:WCS",
  OgcApiFeatures: "OGC:API features",
} as const;
export type OGCWebServiceReadProtocolEnum =
  (typeof OGCWebServiceReadProtocolEnum)[keyof typeof OGCWebServiceReadProtocolEnum];

/**
 * Check if a given object implements the OGCWebServiceRead interface.
 */
export function instanceOfOGCWebServiceRead(value: object): value is OGCWebServiceRead {
  if (!("protocol" in value) || value["protocol"] === undefined) return false;
  if (!("url" in value) || value["url"] === undefined) return false;
  if (!("layers" in value) || value["layers"] === undefined) return false;
  return true;
}

export function OGCWebServiceReadFromJSON(json: any): OGCWebServiceRead {
  return OGCWebServiceReadFromJSONTyped(json, false);
}

export function OGCWebServiceReadFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): OGCWebServiceRead {
  if (json == null) {
    return json;
  }
  return {
    protocol: json["protocol"],
    url: json["url"],
    layers: (json["layers"] as Array<any>).map(OGCWebServiceLayerReadFromJSON),
  };
}

export function OGCWebServiceReadToJSON(json: any): OGCWebServiceRead {
  return OGCWebServiceReadToJSONTyped(json, false);
}

export function OGCWebServiceReadToJSONTyped(
  value?: OGCWebServiceRead | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    protocol: value["protocol"],
    url: value["url"],
    layers: (value["layers"] as Array<any>).map(OGCWebServiceLayerReadToJSON),
  };
}
